import { Injectable } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { LanguageService } from '../../../services/language.service';

@Injectable()
export class AppInitializer {
  constructor(
    private authService: AuthService,
    private languageService: LanguageService) {
  }

  init(): Promise<any> {
    this.languageService.init();
    return this.authService.configure();
  }
}

export function appInitializerFactory(provider: AppInitializer) {
  return (): Promise<any> => provider.init();
}
